import {START_RESETPASSWORD,END_RESETPASSWORD} from "./action";

const initState   =     {
    isProgress:false,
    error:null,
    success:null
}

export  function resetPasswordReducer(state=initState,action){
    switch(action.type){
        case START_RESETPASSWORD:
            return {
                ...state,
                isProgress:true,
                error:null,
                success:null
            };
        case END_RESETPASSWORD:
            return {
                ...state,
                isProgress:false,
                error:action.payload.error,
                success:action.payload.success
            }
        default:
            return state;
    }
}